module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-vault-2.04b4fe35.svg";